import { render, staticRenderFns } from "./cancel.vue?vue&type=template&id=1f653347&"
import script from "./cancel.vue?vue&type=script&lang=ts&"
export * from "./cancel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports